package com.ai.mitra.domain.use_cases

import com.ai.mitra.domain.respository.GeminiRepository
import org.koin.core.component.KoinComponent


class GetAllGroupUserCase(private val geminiRepository: GeminiRepository) : KoinComponent {
    suspend fun  getGroupList() = geminiRepository.getGroupList()

}